import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MemberProfileDetailsPage } from './member-profile-details.page';
import { DateSelectorModule } from '../shared/date-selector.module';
import { ListCardModule } from '../shared/list-card.module';

const routes: Routes = [
  {
    path: '',
    component: MemberProfileDetailsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ListCardModule,
    DateSelectorModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MemberProfileDetailsPage]
})
export class MemberProfileDetailsPageModule {}
